import { clsx } from 'clsx';
import * as React from 'react';
import { useGetIsMobileDevice } from '../../hooks';
import * as styles from './LeftAdornment.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var LeftAdornmentComponent = function LeftAdornmentComponent(props) {
  var isMobileDevice = useGetIsMobileDevice();
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles['left-adornment'], isMobileDevice && styles['mobile']),
    children: props.children
  });
};
export var LeftAdornment = /*#__PURE__*/React.memo(LeftAdornmentComponent);